// @ts-nocheck
/**
 * ツインキーシステム - スキルモジュール
 *
 * スキル関連のすべてのエクスポートを集約
 */

// デフォルトエクスポート用インポート（ESLint: import/first対応）
import attributeSkills from './attributeSkills';
import roleSkills from './roleSkills';
import uniqueSkills from './uniqueSkills';
import skillResolver from './skillResolver';

// 属性スキル
export {
  SKILL_EFFECT_TYPES,
  STATUS_TYPES,
  BUFF_TYPES,
  ATTRIBUTE_SKILLS,
  FIRE_SKILLS,
  WATER_SKILLS,
  LIGHT_SKILLS,
  DARK_SKILLS,
  FUTURE_SKILLS,
  PRIMITIVE_SKILLS,
  NEUTRAL_SKILLS,
  getAttributeSkills,
} from './attributeSkills';

// 役割スキル
export {
  HEALER_SKILLS,
  TANK_SKILLS,
  SPEED_SKILLS,
  ROLE_SKILLS,
  getRoleSkills,
} from './roleSkills';

// 固有スキル
export {
  UNIQUE_SKILLS,
  hasUniqueSkills,
  getUniqueSkills,
  registerUniqueSkills,
  unregisterUniqueSkills,
  getUniqueSkillCardIds,
} from './uniqueSkills';

// スキル解決
export {
  resolveSkills,
  getSkillsForCard,
  getSkillSource,
  getSkillSourceDisplayName,
  SKILL_UNLOCK_LEVELS,
  getSkillUnlockStatus,
  isSkillUnlocked,
  getNextSkillUnlockLevel,
  createSkillInstances,
  initializeSkillsForBattle,
  applySkillCooldown,
  tickSkillCooldown,
  isSkillReady,
} from './skillResolver';

// デフォルトエクスポート
export default {
  ...attributeSkills,
  ...roleSkills,
  ...uniqueSkills,
  ...skillResolver,
};
